var map = {
	"./Square_0.jpg": 38207,
	"./Square_1.jpg": 25538,
	"./Square_2.jpg": 54797,
	"./Square_3.jpg": 53872,
	"./Square_4.jpg": 95523,
	"./Square_5.jpg": 56998,
	"./Square_6.jpg": 14769,
	"./Square_7.jpg": 1044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87419;